._104soko0 {
  min-height: 24px;
  padding: 2px 6px;
  font-weight: 500;
  font-size: 12px;
  line-height: 1.3;
  letter-spacing: -0.01em;
}